import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initGA, trackPageview } from "@/lib/analytics";

/**
 * Mounts once at app root. Initializes GA4 (if configured) and
 * fires a page_view event on every route change.
 */
export default function AnalyticsRouter() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    // Small delay so the new page's document.title is picked up
    const t = setTimeout(() => {
      trackPageview(location.pathname + location.search);
    }, 100);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
